import api from './api'
export default {
    getIps(){
        return api.execute(`get`,`/deamonwh`)
    }
}